module.exports = __webpack_public_path__ + "static/landing-header.c1d3434e.png";